/**
 * Environment configuration for customer-frontend
 * 
 * Supports three environments: development, staging, production
 * 
 * Usage:
 * import { getApiUrl } from '@/lib/env';
 * const apiUrl = getApiUrl();
 */

export type Environment = 'development' | 'staging' | 'production';

export function getEnvironment(): Environment {
  const env = import.meta.env.MODE || import.meta.env.VITE_ENV || 'development';
  
  if (env === 'production' || env === 'prod') {
    return 'production';
  }
  if (env === 'staging' || env === 'stage') {
    return 'staging';
  }
  return 'development';
}

export function getApiUrl(): string {
  const env = getEnvironment();
  
  // Check for explicit API URL override
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // Environment-specific defaults
  const urls: Record<Environment, string> = {
    development: 'http://localhost:3000',
    staging: 'https://api-staging.yourdomain.com',
    production: 'https://api.yourdomain.com',
  };
  
  return urls[env];
}

export function getGeoComplyLicenseKey(): string {
  return import.meta.env.VITE_GEOCOMPLY_LICENSE_KEY || '';
}

export function getGeoComplySdkUrl(): string {
  return import.meta.env.VITE_GEOCOMPLY_SDK_URL || 
         'https://stg-cdn.geocomply.com/342/gc-html5.js';
}

